import React, { CSSProperties, createElement } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Serializer, Question, ElementFactory, IElement, SvgRegistry, SurveyError } from 'survey-core';
import { SurveyQuestionElementBase, ReactQuestionFactory } from 'survey-react-ui';
import { SurveyCreator } from 'survey-creator-react';
import { localization } from 'survey-creator-core';
import { MdHomeFilled } from 'react-icons/md';
import RandoxHomeTestAddressField, { Address } from './Randox/RandoxHomeTestAddressField';

export const CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE = 'randox-address-fields';

SvgRegistry.registerIconFromSvg(
  CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE,
  ReactDOMServer.renderToString(<MdHomeFilled size="large" />)
);
const locale = localization.getLocale('');
locale.qt[CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE] = 'Randox Address Fields';

export class SurveyRandoxAddressFields extends Question {
  getType() {
    return CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE;
  }

  get address(): Address {
    return this.value || {};
  }

  hasErrors() {
    if (this.address?.postcode && this.address?.addressLine1) return false;

    this.clearErrors();

    if (!this.address?.postcode) {
      this.addError(new SurveyError('Postcode is required', this));
      return true;
    }

    if (!this.address?.addressLine1) {
      this.addError(new SurveyError('Address Line 1 is required', this));
      return true;
    }

    return true;
  }
}

Serializer.addClass(
  CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE,
  [],
  function () {
    return new SurveyRandoxAddressFields('');
  },
  'question'
);

export class RandoxAddressFields extends SurveyQuestionElementBase {
  constructor(props: any, bearerToken: string) {
    super(props);
    this.state = { value: this.question.value, model: props.creator.props?.model, bearerToken };
  }
  get question() {
    return this.questionBase;
  }
  get value() {
    return this.question.value;
  }

  get style() {
    return this.question.getPropertyValue('readOnly') || this.question.isDesignMode
      ? ({ pointerEvents: 'none' } as CSSProperties)
      : undefined;
  }

  renderElement() {
    const onAddressChange = (address: Address) => {
      this.question.value = address;
    };
    return (
      <div style={this.style}>
        <RandoxHomeTestAddressField onAddressChange={onAddressChange} />
      </div>
    );
  }
}

ReactQuestionFactory.Instance.registerQuestion(CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE, (props) => {
  // @ts-ignore - React createElement type compatibility issue
  return createElement(RandoxAddressFields, props);
});

const CustomizeSurveyRandoxAddressFields = (surveyCreator?: SurveyCreator) => {
  ElementFactory.Instance.registerElement(CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE, (name: string) => {
    return new SurveyRandoxAddressFields(name) as IElement;
  });

  if (surveyCreator) {
    surveyCreator.onQuestionAdded.add((sender, options) => {
      const question = options.question;
      if (question.getType() === CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE) {
        question.name = CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE;
      }
    });
  }

  if (surveyCreator && !surveyCreator.toolbox.getItemByName(CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE)) {
    surveyCreator.toolbox.addItem({
      name: CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE,
      title: CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE,
      iconName: '',
      json: { type: CUSTOM_RANDOX_HOME_ADDRESS_QUESTION_TYPE },
      category: 'Custom Type',
      className: 'svd_custom_type',
      isCopied: false
    });
  }
};

export default CustomizeSurveyRandoxAddressFields;
